import { useContext, useEffect, useMemo, useState } from "react"
import { ToastContext } from "../../../context/ToastContext";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { dateConvert, dateHoverRange } from "../../../utils/Helper";
import _ from "underscore";

export const useSubmitTimesheet = (props) => {
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [loader, setLoader] = useState(false)
    const [timesheetPendingData, setTimesheetPendingData] = useState([]);
    const [selectedData, setSelectedData] = useState([]);
    const [filterValues, setFilterValues] = useState({ date: props?.hover, users: [], isChange: false });
    const colDefs = [
        { headerName: "User name", field: "user_display_name", flex: 0.2 },
        {
            headerName: "Date", field: "pending_date", cellStyle: { textAlign: "center" },
            valueFormatter: params => dateConvert(params.value, "date"), flex: 0.3
        },
        { headerName: "Logged Hours", field: "logged_hours", flex: 0.3, headerClass: "header-wrap", cellStyle: { textAlign: "center" }, },
        { headerName: "Total Hours", field: "total_hours", flex: 0.3, headerClass: "header-wrap", cellStyle: { textAlign: "center" }, },
        // {
        //     headerName: "Remark", field: "remark", editable: true, flex: 0.7,
        //     cellRenderer: function (params) {
        //         return (
        //             <div>
        //                 <span>
        //                     <input
        //                         style={{ width: "100%" }}
        //                         type="text"
        //                         value={params.data.remark || ''}
        //                         onBlur={() => handleRowData(params)}
        //                         onChange={(e) => {
        //                             const newValue = e.target.value;
        //                             params.setValue(newValue);
        //                         }}
        //                     />
        //                 </span>
        //             </div>
        //         );
        //     }
        // },
    ];

    useEffect(() => {
        filterValues?.apiCall && getPendingTimesheet();
    }, [filterValues?.apiCall])

    // get pending timesheet
    const getPendingTimesheet = async (flag) => {
        try {
            let start = "";
            let end = "";
            if ((filterValues?.date?.[0] && !filterValues?.date?.[1]) || (!filterValues?.date?.[0] && filterValues?.date?.[1])) {
                showInfo("Info", "Please select valid date range");
                return;
            } else if (filterValues?.date?.[0] && filterValues?.date?.[1]) {
                start = (typeof filterValues?.date?.[0] === "string" ? filterValues?.date?.[0] : dateHoverRange(filterValues?.date?.[0])) || "";;
                end = (typeof filterValues?.date?.[1] === "string" ? filterValues?.date?.[1] : dateHoverRange(filterValues?.date?.[1])) || "";;
            }
            !flag && setLoader(true)
            const payload = {
                "from_date": start || "",
                "to_date": end || "",
                "requested_user_code": _.pluck(filterValues?.users, "user_code")?.toString() || ""
            };
            const res = await services.getInvokeRemote('POST', Urls('GETPENDINGTIMESHEETSUMMARY'), payload);
            if (res?.body?.error_status === false) {
                setTimesheetPendingData(res?.body?.data?.timesheet_Details);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false)
            setFilterValues((prev) => ({ ...prev, apiCall: false, isChange: false }));
        }
    };

    const addRemark = async () => {
        if (selectedData?.length > 0) {
            const payload = {
                "tvp_timesheet_update": selectedData
            };
            try {
                const res = await services.getInvokeRemote('POST', Urls('UPDATEPENDINGTIMESHEET'), payload);
                if (res?.body?.data) {
                    showSuccess('Success', res.body.message)
                    getPendingTimesheet(true)
                } else {
                    showError("Error", res.body.errorMessage)
                }
            } catch (error) {
                console.error(error);
            }
        } else {
            showInfo("Info", "Please Add Remark.");
        }
    }

    // const handleRowData = (params) => {
    //     if (params.value !== undefined) {
    //         const updatedRemarks = timesheetPendingData.map(row => {
    //             if (row.timesheet_ledger_id === params.data.timesheet_ledger_id) {
    //                 setSelectedData([...selectedData, { timesheet_ledger_id: params.data.timesheet_ledger_id, remarks: params.value }])
    //                 return { ...row, remark: params.value };
    //             }
    //             return row;
    //         });
    //         setTimesheetPendingData(updatedRemarks);
    //     }
    // };

    return useMemo(() => ({
        getPendingTimesheet, loader, timesheetPendingData, colDefs, filterValues, setFilterValues
    }), [getPendingTimesheet, loader, timesheetPendingData, colDefs, filterValues, setFilterValues])
}